<template>
  <section class="app-transporte">
    <v-container grid-list-xl>
      <v-layout row wrap>
        <v-flex lg12 sm12 xs12>
          <router-view></router-view>
        </v-flex>
      </v-layout>
    </v-container>
  </section>
</template>

<script>
export default {
  metaInfo: {
    title: "Passe Livre Intermunicipal - Central de Serviços"
  }
};
</script>
